<template>
  <span
    class="ui-select__check"
    :class="{ 'is-checked': checked || indeterminate }"
    aria-hidden="true"
  >
    <Minus v-if="indeterminate && !checked" :size="16" :stroke-width="3" />

    <Transition v-else name="ui-tick">
      <span v-if="checked" class="ui-tick-mark">
        <Check :size="16" :stroke-width="3" />
      </span>
    </Transition>
  </span>
</template>

<script setup lang="ts">
import { Check, Minus } from "lucide-vue-next";

withDefaults(
  defineProps<{
    checked?: boolean;
    indeterminate?: boolean;
  }>(),
  {
    checked: false,
    indeterminate: false,
  },
);
</script>
